module.exports = __webpack_public_path__ + "static/img/artist-acey-banner@2x.6641aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artist/artist-acey-banner@2x.png
// module id = JiWG
// module chunks = 12